import type { ReactNode } from "react";
import { cx } from "./cx";

export type FieldSize = "sm" | "md" | "lg";

export const FIELD_HEIGHT: Record<FieldSize, string> = {
  sm: "h-(--control-sm)",
  md: "h-(--control-md)",
  lg: "h-(--control-lg)",
};

/** `required` adds a quiet marker; the form, not the browser, says what's missing. */
export function FieldLabel({ children, required }: { children: ReactNode; required?: boolean }) {
  return (
    <span className="mb-2 block type-label text-text-strong">
      {children}
      {required && <span className="ml-2 type-small font-normal text-text-muted">Required</span>}
    </span>
  );
}

/** Hint or error under a field. An error replaces the hint and is announced. */
export function FieldNote({ id, error, hint }: { id: string; error?: string; hint?: string }) {
  if (!error && !hint) return null;
  return (
    <span id={id} role={error ? "alert" : undefined} className={cx("mt-2 block type-small", error ? "text-danger-700" : "text-text-muted")}>
      {error || hint}
    </span>
  );
}

/** Hidden native input behind a custom box. Keeps keyboard, form and screen-reader behaviour. */
export const VISUALLY_HIDDEN_INPUT = "peer absolute h-0 w-0 opacity-0";
